export const warningCodes = [
  "EM067",

  "EM120",

  "EM122",

  "EM125",

  "EM181",

  "PY022",

  "PY023",

  "PY024",

  "PY025",

  "PY026",

  "PY027",

  "PY035",

  "PY036",

  "PY061",

  "PY062",

  "PY063",

  "PY064",

  "PY065",

  "PY066",

  "PY067",

  "PY068",

  "PY069",

  "PY070",

  "PY071",

  "PY072",

  "PY085",

  "PY087",

  "PY088",

  "PY089",

  "PY099",

  "PY100",

  "PY104",

  "PY105",

  "PY106",

  "PY111",

  "PY114",

  "PY115",

  "PY117",

  "PY129",

  "PY140",

  "PY146",
];
